/**
 * Route for `click-log-report`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickLogReportPage } from "../features/click-log-report/ClickLogReportPage";

export const clickLogReportRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/click-log-report",
	component: ClickLogReportPage,
});

export default clickLogReportRoute;
